import { TriangleAlert } from "lucide-react";
import { Link } from "react-router";

import { formatCount } from "../../utils/format";

export function PendingNotice({
	count,
	obraKey,
}: {
	count: number;
	obraKey: string | undefined;
}) {
	if (count <= 0) return null;
	const days = count === 1 ? "dia" : "dias";
	return (
		<div className="pending-notice" role="status">
			<TriangleAlert className="pending-notice__icon" aria-hidden="true" />
			<p className="pending-notice__text">
				Há {formatCount(count)} {days} sem preenchimento neste mês — os totais
				podem estar incompletos.
			</p>
			<Link to={`/${obraKey ?? ""}/equipe`} className="pending-notice__link">
				Ir para a Equipe
			</Link>
		</div>
	);
}
